import DashboardService from '@/services/DashboardService-bmw';

const FilterModes = [
  { number: 1, name: 'regions', option: 'Regions' },
  { number: 2, name: 'subregions', option: 'Subregions' },
  { number: 3, name: 'nscs', option: 'NSCs' },
  { number: 4, name: 'nscsub', option: 'SubNSCs' },
  { number: 5, name: 'areas', option: 'Areas' },
  { number: 6, name: 'dealergroups', option: 'Dealergroups' },
  { number: 7, name: 'outlets', option: 'ClientLocations' },
];

export default {
  data() {
    return {
    };
  },
  methods: {
    handleRejection(p) {
      return p.catch(err=> ({ error: err }));
    },

    // Ermittele alle Ordner für die Brands
    async getMultipleResults(filter, cancelToken, options) {
      let calls = [];
      let filterTemplate = JSON.stringify(filter);

      // Ebene der Abfrage ermitteln
      let stage = this.getActualFilterMode(filter);

      // Filterobjekte ermitteln
      let filterItems = this.getFilters(JSON.parse(filterTemplate), options, stage);

      // für alle Filterobjekte API Calls erstellen
      _.forEach(filterItems, function(x) {
        // Clone des übergebenen Filters erstellen
        let callFilter = JSON.parse(filterTemplate);
        // Aktive Filterebene mit einzelnem Ausdruck befüllen
        _.set(callFilter, stage.mode.name, x);
        calls.push(DashboardService.getDashboard(callFilter, cancelToken));
      });

      // Alle Calls abwarten
      let resultset = await Promise
        .all(calls.map(this.handleRejection))
        .catch(err=> ({ error: err }));

      // Filterinformationen an das Resultat zum vereinfachten Mapping in der Anzeige anhängen
      for (let i = 0; i < resultset.length; i++) {
        resultset[i].customFilterStage = JSON.parse(JSON.stringify(stage));
        resultset[i].customFilterStage.text = filterItems[i];
      }

      return resultset;
    },

    getFilters(filter, options, stage) {
      if (stage.text.length > 0) {
        return _.split(stage.text.replace(/,/g, '|'), '|');
      }

      let items = [];
      let obj = _.get(options, stage.mode.option, undefined);
      if (obj === undefined) { console.error(options); };
      _.forEach(obj, function(x) {
        items.push(x.id);
      });
      return items;
    },

    getActualFilterMode(filter) {
      let result = this.createFilterMode();

      for (var i = FilterModes.length - 1; i >= 0; i--) {
        let filterText = _.get(filter, FilterModes[i].name, undefined);
        if (filterText.length > 0) {
          result.mode = FilterModes[i];
          result.text = filterText;
          break;
        }
      }

      if (result.mode === null) {
        result.mode = FilterModes[0];
      }

      return result;
    },

    createFilterMode() {
      return {
        mode: null,
        text: ''
      };
    }
  }
};
